export type ThemeSize = 'xs' | 'sm' | 'md' | 'lg';

export const ThemeModes = {
  System: 'system',
  Light: 'light',
  Dark: 'dark'
} as const;

export type ThemeMode = (typeof ThemeModes)[keyof typeof ThemeModes];

// Global theme variants
export type ThemeVariant =
  | 'custom'
  | 'default'
  | 'primary'
  | 'secondary'
  | 'transparent'
  | 'success'
  | 'danger'
  | 'warn'
  | 'info'
  | 'ghost'
  | 'outline';
